import axios from "axios";
import { SERVER_BASE_URL } from "../../constants/constants";


export const UserService = {


    async updateUser(token: string, content: any) {
        const url = SERVER_BASE_URL + "api/user";
        return axios({
            method: 'post',
            url: url,
            data: JSON.stringify(content),
            headers: {
                'x-auth-token': token,
                'Content-Type': `application/json`
            },
        });
    },

    async updateSurvey(token: string, content: any) {
        const url = SERVER_BASE_URL + "api/survey";
        return axios({
            method: 'post',
            url: url,
            data: content,
            headers: {
                'x-auth-token': token,
                'Content-Type': `application/json`
            },
        });
    },
}